import React, { createContext, useContext, useState, useEffect } from "react";

const NotificationContext = createContext();

export const useNotifications = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  // readNotifications state'ini localStorage'dan başlat
  const [readNotifications, setReadNotifications] = useState(() => {
    try {
      const stored = localStorage.getItem("readNotifications");
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      console.error("Okunmuş bildirimler okunamadı:", error);
      return {};
    }
  });

  // localStorage'dan bildirimleri yükle
  useEffect(() => {
    try {
      const storedNotifications = localStorage.getItem("notifications");
      if (storedNotifications) {
        setNotifications(JSON.parse(storedNotifications));
      }
    } catch (error) {
      console.error("Bildirimler parse edilemedi:", error);
      localStorage.removeItem("notifications");
    }
  }, []);

  // Bildirimleri localStorage'a kaydet
  useEffect(() => {
    try {
      localStorage.setItem("notifications", JSON.stringify(notifications));
    } catch (error) {
      console.error("Bildirimler kaydedilemedi:", error);
    }
  }, [notifications]);

  // Okunmuş bildirimleri localStorage'a kaydet
  useEffect(() => {
    try {
      localStorage.setItem(
        "readNotifications",
        JSON.stringify(readNotifications)
      );
    } catch (error) {
      console.error("Okunmuş bildirimler kaydedilemedi:", error);
    }
  }, [readNotifications]);

  const addNotification = (notification) => {
    const newNotification = {
      id: Date.now(),
      timestamp: new Date().toISOString(),
      read: false,
      ...notification,
    };
    setNotifications((prev) => {
      const updated = [newNotification, ...prev];
      return updated;
    });
  };

  // markAsRead fonksiyonunu güvenli hale getir
  const markAsRead = (id, userId) => {
    setReadNotifications((prev) => {
      const currentUserReads = Array.isArray(prev[userId]) ? prev[userId] : [];
      return {
        ...prev,
        [userId]: [...currentUserReads, id],
      };
    });
  };

  // markAllAsRead fonksiyonunu güvenli hale getir
  const markAllAsRead = (userId) => {
    const userNotificationIds = getUserNotifications({ user_id: userId }).map(
      (n) => n.id
    );
    setReadNotifications((prev) => {
      const currentUserReads = Array.isArray(prev[userId]) ? prev[userId] : [];
      return {
        ...prev,
        [userId]: [...currentUserReads, ...userNotificationIds],
      };
    });
  };

  const getUserNotifications = (user) => {
    if (!user) {
      return [];
    }
    return notifications.filter((notification) => {
      // Kullanıcı ID'sine göre bildirimleri filtrele
      if (notification.targetUserId === user.user_id) {
        return true;
      }
      // Rol bazlı bildirimleri filtrele
      if (notification.targetRole === "all") {
        return true;
      }
      if (notification.targetRole === "admin" && isAdmin(user)) {
        return true;
      }
      if (notification.targetRole === "employee" && isEmployee(user)) {
        return true;
      }
      return false;
    });
  };

  const getUnreadCount = (user) => {
    if (!user) return 0;
    const userNotifications = getUserNotifications(user);
    // readNotifications[user.user_id] bir dizi değilse boş dizi kullan
    const readIds = Array.isArray(readNotifications[user.user_id])
      ? readNotifications[user.user_id]
      : [];
    return userNotifications.filter((n) => !readIds.includes(n.id)).length;
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        addNotification,
        markAsRead,
        markAllAsRead,
        getUserNotifications,
        getUnreadCount,
        readNotifications,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

const isAdmin = (user) => {
  if (!user) return false;
  return (
    user.role === "admin" ||
    user.role_id === 1 ||
    user.role_name === "maintenance_admin" ||
    user.role_id === 3
  );
};

const isEmployee = (user) => {
  if (!user) return false;
  return user.role === "employee" || user.role_id === 2;
};
